import React, { useCallback, useMemo, useState } from 'react';
import { telemetry } from '../../../@vendor/Posthog';
import { TaskData } from '../../../api/endpoints/tasks';
import { Menu } from '../../../ui';
import { MenuButton } from '../../../ui/MenuButton';
import { SelectUserView } from '../../common/SelectUserView';
import { Flexer } from '../elements/LayoutElements';
import { useOnBulkDeleteTasks, useOnBulkPatchTasks } from './TaskActions';
import { TaskStatusMenu } from './TaskStatusCell';

export const TaskBulkActionMenu = ({ selection, onAction }: { selection: TaskData[], onAction: () => void }) => {

    const [open, setOpen] = useState(false);

    const onActionInner = useCallback((complete: boolean) => {
        setOpen(false);
        if (complete) {
            onAction();
        }
    }, [onAction]);

    const taskIds = useMemo(() => selection.map(x => x.id), [selection]);
    // const onBulkMoveBoards = useOnBulkMoveBoards(boardIds, setClosed);
    // const onBulkArchiveBoards = useOnBulkArchiveBoards(boardIds, setClosed);
    const onBulkPatchTasks = useOnBulkPatchTasks(taskIds, onActionInner);
    const onBulkDeleteTasks = useOnBulkDeleteTasks(taskIds, onActionInner);

    const label = !!selection.length
        ? `Bulk Actions (${selection.length})`
        : 'Bulk Actions';

    const StatusMenu = () => <TaskStatusMenu onSelect={x => {
        onBulkPatchTasks({ status: x });
        telemetry.emit('tasksView.bulkMenu.setStatus', { taskIds, status: x });
    }} />;

    const AssignMenu = () => {
        return <SelectUserView title="Assign Action To..." allowSearch onSelect={next => {
            onBulkPatchTasks({ userId: next.id });
            telemetry.emit('tasksView.bulkMenu.setAssignee', { taskIds });
        }} />;
    };

    return <MenuButton disabled={!selection.length} label={label} {...{ open, setOpen }}>
        <Flexer width="12">
            <Menu>
                <Menu.Section first>
                    <Menu.SubMenuItem menu={StatusMenu}>
                        <Menu.ItemText>
                            Set Status
                        </Menu.ItemText>
                        <Menu.SubMenuIndicator />
                    </Menu.SubMenuItem>
                    <Menu.SubMenuItem menu={AssignMenu}>
                        <Menu.ItemText>
                            Assign To
                        </Menu.ItemText>
                        <Menu.SubMenuIndicator />
                    </Menu.SubMenuItem>
                </Menu.Section>
                <Menu.Section>
                    <Menu.Item data-action="tasksView.bulkMenu.delete" onClick={onBulkDeleteTasks}>
                        <Menu.ItemText>
                            Delete Actions
                        </Menu.ItemText>
                    </Menu.Item>
                </Menu.Section>
            </Menu>
        </Flexer>
    </MenuButton>;
};
